// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wVBICeo57QeeuzdKUEzI{align-items:center;gap:8px;display:flex}.wVBICeo57QeeuzdKUEzI .U34cQ2DV4sMigjZIyOah{border:1px solid var(--black-20);background-position:50%;background-repeat:no-repeat;background-size:cover;border-radius:100%;justify-content:center;align-items:center;width:48px;height:48px;display:flex}.wVBICeo57QeeuzdKUEzI .U34cQ2DV4sMigjZIyOah.jpxZXXpeiWA2ULGpBDb3{border-radius:6px}.wVBICeo57QeeuzdKUEzI .nZXrq9ZyjAY7a8IQiAhP{max-width:300px;margin-top:4px;display:block}.mefgvKGd_oDtFTqKhDSj{flex-direction:column;padding:0 0 2px 4px;display:flex}.Tk7NgJPn_2gSVwU09yDd{height:-webkit-max-content;height:max-content}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logoWrap": `wVBICeo57QeeuzdKUEzI`,
	"logo": `U34cQ2DV4sMigjZIyOah`,
	"square": `jpxZXXpeiWA2ULGpBDb3`,
	"logoSubtitle": `nZXrq9ZyjAY7a8IQiAhP`,
	"labelWrap": `mefgvKGd_oDtFTqKhDSj`,
	"uploadButton": `Tk7NgJPn_2gSVwU09yDd`
};
export default ___CSS_LOADER_EXPORT___;
